import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

// Setting up the PDF.js worker from CDN
pdfjs.GlobalWorkerOptions.workerSrc = 
  `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

function PdfViewer({ fileUrl, width = 600 }) {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setLoading(false);
  }
  
function onDocumentLoadError(err) {
  console.error('PDF Error details:', err);
  console.error('PDF Error message:', err.message);
  console.error('File URL was:', fileUrl);
  setError('Could not load PDF. Please try downloading the file instead.');
  setLoading(false);
}

  function changePage(offset) {
    setPageNumber(prevPageNumber => prevPageNumber + offset);
  }

  function previousPage() {
    changePage(-1);
  }

  function nextPage() {
    changePage(1);
  }

  if (!fileUrl) {
    return <div className="pdf-error">No PDF file provided</div>;
  }

  return (
    <div className="pdf-viewer">
      {loading && <div className="pdf-loading">Loading PDF...</div>}
      {error && <div className="pdf-error">{error}</div>}
      
      <Document
        file={fileUrl}
        onLoadSuccess={onDocumentLoadSuccess}
        onLoadError={onDocumentLoadError}
        loading={<div>Loading PDF...</div>}
      >
        <Page 
          pageNumber={pageNumber} 
          width={width}
          renderTextLayer={true}
          renderAnnotationLayer={true}
        />
      </Document>
      
      {numPages && (
        <div className="pdf-controls">
          <button 
            onClick={previousPage} 
            disabled={pageNumber <= 1}
            className="pdf-control-btn"
          >
            Previous
          </button>
          <span className="pdf-page-info">
            Page {pageNumber} of {numPages}
          </span>
          <button 
            onClick={nextPage} 
            disabled={pageNumber >= numPages}
            className="pdf-control-btn"
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
}

export default PdfViewer;